export default __webpack_public_path__ + "static/media/click-1.a3299dda.ogg";